<template>
    <CModal
      :title="title"
      :color="color"
      :show.sync="showModal"
      class="basic-modal-color"
    >   
        <CForm id="guest_confirm_form" method="POST" enctype="multipart/form-data">
          <CRow>      
            <CCol md="12" style="text-align: center;">
              ¿Estás seguro que deseas enviar los boletos al invitado?
              <br /> <br/>
              <b>{{form.name}}</b>
              <br /> <br/>
              Los boletos serán enviados por al correo electrónico que haya sido registrado con el Invitado.
            </CCol>              
          </CRow>
        </CForm>
        <template #footer>
          <CButton @click="closeModal" color="secondary">Cancelar</CButton>
          <CButton @click="sendTickets" :color="color">Enviar Boletos</CButton>
        </template>
    </CModal>
</template>

<script>
import store from '@/store';
import ws from '@/services/events_guests';

export default {
  name: 'SendTicketModal',
  props: {
  },
  components: {
  },
  data () {
    return {
      event: false,
      showModal: false,
      title: "Enviar Boletos",
      color: "info",
      isEdit: false,
      form: this.getEmptyForm(),
      submitted: false,      
      classesOptions: [],
      statusOptions: [],
      senderOptions: [{ "label": "Correo Electrónico", "value": "email" }, { "label": "Whatsapp", "value": "whatsapp" }],
      sender_type: 'email'
    }
  },
  mounted: async function() {    
    
  },
  methods: {
    showSendModal (item, event) {
      this.showModal = true;
      this.color = "info";
      this.title = 'Enviar Boletos';
      this.isEdit = false;
      this.submitted = false;

      this.event = event;

      this.form = {
          id: item.id,
          name: item.name,
      };

    },
    async sendTickets (item) {
      this.loading();

      let response = await ws.sendTickets({id: this.form.id, sender: this.sender_type});

      this.loaded();
      this.showToast(response.type, response.message);

      if(response.type == "success"){
        this.closeModal();
      }                 
    },
    closeModal () {
      this.showModal = false;

      this.form = this.getEmptyForm()
      this.submitted = false
    },
    getEmptyForm () {
      return {
          id: 0,
          name: '',
      }
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  },
}
</script>
<style>
.basic-modal-color .modal-header{
  background-color: #668269 !important;
}
</style>